import {Component, OnInit} from '@angular/core';

import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {Router} from '@angular/router';

import {BsModalService} from 'ngx-bootstrap/modal';
import {LoadingService} from '../../../services/loading.service';

import {SignService} from '../../sign.service';
import {NotificationsService} from '../../../services/notifications.service';

import * as CryptoJS from 'crypto-js';
import * as localforage from 'localforage';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'asv-signin',
  templateUrl: 'signin.component.html',
  styles: [`
    :host {
      width: 100%;
    }
  `]
})
export class SigninComponent implements OnInit {
  public showErrors: boolean;
  public signinForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private modalService: BsModalService,
    private loadingService: LoadingService,
    private signService: SignService,
    private notificationsService: NotificationsService,
    private translateService: TranslateService
  ) {
    this.showErrors = false;
  }

  ngOnInit() {
    this.makeForm();
    this.showErrors = false;
  }

  public makeForm() {
    this.signinForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  public onSubmit() {
    if (this.signinForm.valid) {
      this.loadingService.show();
      this.showErrors = false;
      return this.signService.signin(this.signinForm.value);
    } else {
      this.showErrors = true;
    }
  }

  public getErrorMessage(field) {
    let errorMessage: string;
    let translationCode: string;
    if (field.hasError('required')) {
      translationCode = 'general.form.not_empty';
    }
    if (field.hasError('email')) {
      translationCode = 'sign.email.not_email';
    }
    this.translateService.get(translationCode).subscribe((res: string) => {
      errorMessage = res;
    });

    return errorMessage;
  }
}
